import { render, staticRenderFns } from "./project-api-list.vue?vue&type=template&id=41b4d982&scoped=true&"
import script from "./project-api-list.vue?vue&type=script&lang=js&"
export * from "./project-api-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b4d982",
  null
  
)

export default component.exports